import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ContentAnalyticsViewersUnifiedQuery } from './queries/ContentAnalyticsViewersUnifiedQuery.graphql.ts';

export const preloadContentAnalyticsViewers = (contentId: string) =>
	query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ContentAnalyticsViewersUnifiedQuery,
		variables: { contentId },
	});
